import React from 'react'
import { Helmet } from 'react-helmet'

const SEO = ({title, description, image}) => {
    return (
        <Helmet>
            <meta charSet="utf-8"/>
            <title>Minimuni {title && `| ${title}`}</title>
            <meta name="title" content={`Minimuni | ${title}`}/>

            <meta property="og:description" content={description ?  description : "Hello world"}/>
            <meta name="description" content="Blogs about montessori, art works, our environment, charities, culture and many other.
                Dedicated to help each and everyone of us. Bring up children who'll love and embrace their culture and 
                becoming a better person."/>

            <meta property="og:type" content="website"/>
            <meta property="og:url" content="https://minimuni-blog.netlify.app/"/>
            <meta property="og:title" content={`Minimuni | ${title}`}/>
            <meta property="og:description" content={description}/>
            <meta property="og:image" content={image}/>

            <meta property="twitter:card" content="summary_large_image"/>
            <meta property="twitter:url" content="https://minimuni-blog.netlify.app/"/>
            <meta property="twitter:title" content={`Minimuni | ${title}`}/>
            <meta property="twitter:description" content={description}/>
            <meta property="twitter:image" content={image}/>
        </Helmet>
    )
}

export default SEO
